import { DisaggregatedMetric, MetricPanelProps } from "../../services/types";
import { getMetricGroupChartId, getMetricGroupOrderIds, getSvgMap } from "../../utils/dashboardUtils";
import MetricCard from "../MetricCard";
import RaceEthnicityChart from "../charts/RaceEthnicityChart";
import SimpleBarChart from "../charts/SimpleBarChart";
import DisaggregateMetricCardAlt from "../DisaggregateMetricCardAlt";
import useVisibility from "../../hooks/useVisibility";

const DemographicMetrics = ({ indicators, categorizedData, tab, geoDetails, geoTag, selectionActive }: MetricPanelProps) => {   
    // check window height for toggling chart display
    const { ref: sectionRef, isVisible } = useVisibility();

    const bgColor = "#225591";
    const barColor = "#00A18A";
    
    const demoOrders = getMetricGroupOrderIds(tab);

    const sortedDemoMetrics = demoOrders.map((order: number[]) => 
        categorizedData.Demographic
            .filter(metric => order.includes(metric.id))
            .sort((a, b) => order.indexOf(a.id) - order.indexOf(b.id))
    );
    console.log('demo data:', sortedDemoMetrics);

    const demoOne: DisaggregatedMetric[] = sortedDemoMetrics[0];

    let metricsForTab = indicators; // Get metrics for the current tab

    if (!metricsForTab || metricsForTab.length === 0) {
        return <div className="flex items-center justify-center text-color-cai-dashboard">No metrics available for {tab}.</div>;
    }

    return (
        <div ref={sectionRef}>
            <p className="text-lacey-text ml-6 text-xs mt-4">Indicators shown below depict demographic details for the population within the selected area.</p>
            <div className="grid grid-cols-3 gap-4 place-items-start ml-4">
                {demoOne.map(metric => (
                    <MetricCard
                        key={metric.id}
                        metric={metric}
                        width="w-full"
                        svg={getSvgMap(metric.id)}
                        disaggData={indicators}
                        geoDetails={geoDetails}
                        geoTag={geoTag}
                        selectionActive={selectionActive}
                    />
                ))}

                {isVisible ? (
                <>
                <div className="col-span-3 w-full pr-4">
                    {categorizedData.Demographic.filter(metric => 
                        metric.id === 363 // HouseholdIncome
                    ).map(metric => (
                        <DisaggregateMetricCardAlt
                            key={metric.id}
                            id={metric.id}
                            metric={metric}
                            title={"Household Income"}
                            subText="Median Household Income:"
                            svg={getSvgMap(metric.id)}
                            disaggData={indicators}
                            geoDetails={geoDetails}
                            geoTag={geoTag}
                            selectionActive={selectionActive}
                            showValue={true}
                            color={bgColor}
                        />
                    ))}
                    <SimpleBarChart indicators={indicators} title="HouseholdIncome" tab="Demographic" chartName="hhincome" height="h-64" barColor={barColor} reverseOrder={false} topFive={false}/>
                </div>

                <div className="col-span-3 w-full pr-4 mb-4">
                    {categorizedData.Demographic.filter(metric => 
                        [getMetricGroupChartId(tab, "race")].includes(metric.id) // Race and Ethnicity
                    ).map(metric => (
                        <DisaggregateMetricCardAlt
                            key={metric.id}
                            id={metric.id}
                            metric={metric}
                            title={"Race & Ethnicity"}
                            subText=""
                            svg={getSvgMap(metric.id)}
                            disaggData={indicators}
                            geoDetails={geoDetails}
                            geoTag={geoTag}
                            selectionActive={selectionActive}
                            showValue={false}
                            color={bgColor}
                        />
                    ))}
                    <RaceEthnicityChart indicators={indicators} title="Race and Ethnicity" tab="Demographic" chartName="race" height="h-64" barColor={barColor} reverseOrder={false} topFive={false}/>
                </div>
                </>
                ) : 
                    <div className="col-span-3 min-h-[700px] mx-auto border-t overflow-hidden">
                        <p className="pt-4 text-xs text-port-text text-center px-10 mb-8">Scroll down or close the storymap window to see selected area statistics.</p>
                    </div>
                }
            </div>
        </div>
    );
}

export default DemographicMetrics;